import { createTranslatedText } from '@dreryk/react-common';
import { InteractiveTable, SecondaryText } from '@dreryk/react-components';

import { StyledNameCell } from './NameCell.styled';

type NameCellProps = {
   readonly index: number;
   readonly name: string;
   readonly additionalInformation: string | null;
};

export const NameCell = (props: NameCellProps): JSX.Element => (
   <StyledNameCell direction={'column'}>
      <InteractiveTable.TextViewCell
         testId={'name'}
         name={'name'}
         index={props.index}
         defaultValue={props.name}
         compact
      />
      <InteractiveTable.CustomCell<string | null>
         testId={'additionalInformation'}
         name={'additionalInformation'}
         index={props.index}
         defaultValue={props.additionalInformation}
         compact
      >
         {(value) => (
            <>
               {value ? (
                  <SecondaryText compact testId={'additionalInformation'} text={createTranslatedText(value)} />
               ) : null}
            </>
         )}
      </InteractiveTable.CustomCell>
   </StyledNameCell>
);
